import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const playProcess = async (payload) => {
    try {
        let { status } = await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/queue`, payload);
        if (status === 200) {
            addNotification({
                title: "Techforce.ai",
                message: "Successfully added to queue",
                type: "success"
            });
        }
        return status;
    } catch (err) {
        if(err.response && err.response.status === 402){
            addNotification({
                title: "Techforce.ai",
                message: "Please upgrade your plan!",
                type: "info"
              });
        }
        else{
            addNotification({
                title: "Techforce.ai",
                message: "Please write to support",
                type: "danger"
            });
        }
    }
};
